import { render, staticRenderFns } from "./DocumentPropertyEdit.vue?vue&type=template&id=6f47ea7b&"
import script from "./DocumentPropertyEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentPropertyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports